<div class="groups">
    <div class="table-container">
        <div class="table-header">
            <div>
                <span class="ltms-widget-title">
                    Channel-wise Response Distribution • {{ displayName }}
                </span><br>
                <span class="ltms-description">
                    View the total responses received across each channel to understand volume trends.
                </span>
            </div>
            <app-score-widget [config]="scoreWidget('drilldown')" (onDownloadClick)="onDownload('Channel-wise Response Distribution')"></app-score-widget>
        </div>
        <div class="table-body">
            <div *ngIf="isDataLoaded; else loader">
                <app-score-table [tableColumns]="responseDistributionHeader" [tableData]="responseDistribution" [tableFooter]="responseDistributionFooter"></app-score-table>
            </div>
            <ng-template #loader>
                <div class="data-loader">
                  <app-ltms-loader></app-ltms-loader>
                </div>
            </ng-template> 
        </div>
        
    </div>
    <div class="table-container">
        <div class="table-header">
            <div>
                <span class="ltms-widget-title">
                    Channel-wise Response Rate • {{ displayName }}
                </span><br>
                <span class="ltms-description">
                    Compare response rates by channel to gauge engagement effectiveness.
                </span>
            </div>
            <app-score-widget [config]="scoreWidget('drilldown')" (onDownloadClick)="onDownload('Channel-wise Response Rate')"></app-score-widget>
        </div>
        <div class="table-body" >
            <div *ngIf="isDataLoaded; else loader">
                <app-score-table [tableColumns]="responseRateDistributionHeader" [tableData]="responseDistribution" [tableFooter]="responseDistributionFooter"></app-score-table>
            </div>
            <ng-template #loader>
                <div class="data-loader">
                  <app-ltms-loader></app-ltms-loader>
                </div>
            </ng-template>
        </div>         
    </div>
</div>
